// import { Outlet, Navigate } from 'react-router-dom';
// import { message} from "antd";
// import React, {useRef, useEffect} from "react";
// import ModalContent from "../constant/ModalContent";
//
//
// const PrivateRoutes = () => {
//
//     const isErrorMessageDisplayedRef = useRef(false);
//     const loginRef = useRef(localStorage.getItem('isLogin') === 'true');
//
//     useEffect(() => {
//         const login = localStorage.getItem('isLogin') === 'true';
//         loginRef.current = login;
//         if (!login && !isErrorMessageDisplayedRef.current) {
//             message.error(ModalContent.PRIVATE_ROUTE_MESSAGE,1)
//             isErrorMessageDisplayedRef.current = true;
//         }
//     }, []);
//
//     return (
//
//             loginRef.current ? <Outlet /> : <Navigate to="/entitlement-server-websheet-frontend" />
//     );
// }
//
// export default PrivateRoutes;
//
//


import { Outlet, Navigate } from 'react-router-dom';
import { message } from "antd";
import {  useRef, useEffect } from "react";

const PrivateRoutes = () => {

    const isErrorMessageDisplayedRef = useRef(false);
    const loginRef = useRef(localStorage.getItem('isLogin') === 'true');

    useEffect(() => {
        const login = localStorage.getItem('isLogin') === 'true';
        loginRef.current = login;
        if (!login && !isErrorMessageDisplayedRef.current) {
            message.error("Please Login to access this page!");
            isErrorMessageDisplayedRef.current = true;
        }
    }, []);

    return (
        loginRef.current ? <Outlet /> : <Navigate to="/" />
    );
}

export default PrivateRoutes;



